import { type Theme, Typography, styled, useTheme } from '@mui/material';
import { yellow } from '@mui/material/colors';
import { type SystemStyleObject } from '@mui/system';
import { getStarIcon } from './helpers/getStarIcon.ts';

const Container = styled('span')({
  display: 'flex',
  flexDirection: 'column',
});

const InnerContainer = styled('span')({
  alignItems: 'center',
  display: 'flex',
});

const OutOf = styled('span')(({ theme }) => ({
  color: theme.supportingTextPrimary,
  fontSize: '1rem',
}));

const Total = styled('span')(({ theme }) => ({
  color: theme.supportingTextPrimary,
  display: 'block',
  fontSize: '0.75rem',
}));

export type LargeProps = {
  compact?: boolean;
  sx?: SystemStyleObject<Theme>;
  voteAverage: number;
  voteCount: number;
};

export const Large = ({ compact, sx = {}, voteAverage, voteCount }: LargeProps) => {
  const theme = useTheme();
  const StarIcon = getStarIcon(voteAverage);

  return (
    <Container sx={sx}>
      {compact ? undefined : (
        <Typography
          sx={{
            [theme.breakpoints.down('sm')]: {
              display: 'none',
            },
            color: theme.supportingTextPrimary,
            fontSize: '0.75rem',
            textAlign: 'center',
          }}
        >
          RATING
        </Typography>
      )}
      <InnerContainer>
        <StarIcon
          sx={{
            color: yellow[600],
            fontSize: '2.5rem',
            marginRight: theme.spacing(0.2),
            width: compact ? '35px' : undefined,
          }}
        />
        <Typography
          className="voteAverageText"
          sx={{
            color: theme.mainTextPrimary,
            display: 'inline-block',
            lineHeight: 1.25,
          }}
          variant="h6"
        >
          <strong>{voteAverage.toFixed(1)}</strong>
          {compact ? undefined : (
            <>
              <OutOf>/10</OutOf>
              <Total>{voteCount.toLocaleString()}</Total>
            </>
          )}
        </Typography>
      </InnerContainer>
    </Container>
  );
};
